import { uniqueId } from "@/views/zhiji/js/common/util.js";

// 初始化子节点
export function initChildNode(maxLevel, level, connector = "") {
    const nextLevel = level + 1;
    if (nextLevel === maxLevel) {
        return {
            uId: uniqueId(),
            type: "Condition",
            level: nextLevel,
            init: true,
            value: {}
        };
    }
    return {
        uId: uniqueId(),
        type: "Group",
        connector: connector || "",
        level: nextLevel,
        children: [initChildNode(maxLevel, nextLevel, connector)]
    };
}
